import SearchBoxToggle from './SearchBoxToggle';
// Styles
import './style.scss';
import { theme } from 'src/theme';

if (theme.mode === 'dark') {
  import(/* webpackChunkName: "dark" */ './style.scss?dark');
}

export default SearchBoxToggle;
